import {Component, Input, OnInit} from '@angular/core';
import {Account} from '@app/types/account';
import {BreakpointObserver, Breakpoints} from '@angular/cdk/layout';
import {environment} from '@env/environment';

@Component({
  selector: 'pp-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class AccountComponent implements OnInit {

  @Input() account: Account;
  isDesktop = true;
  showUpdatePaymentMethod = false;
  ppUiHost = environment.ppUi;

  constructor(private breakpointObserver: BreakpointObserver) { }

  ngOnInit() {
    // Temporarily disable the update payment method link until we disable the option to update to Alternative payment method.
    // this.showUpdatePaymentMethod = this.account  && (this.account.currency.toUpperCase() !== 'VES');

    this.breakpointObserver
    .observe([Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge])
    .subscribe((result) => {
      this.isDesktop = result.matches;
    });
  }

}
